// Enumeraciones del dominio compartidas entre servidor e interfaz.

export const MODULES = [
  'people',
  'services',
  'checkins',
  'giving',
  'groups',
  'calendar',
  'registrations',
  'home',
  'publishing',
  'chat',
  'admin',
] as const;
export type Module = (typeof MODULES)[number];

/** Niveles de permiso, de menor a mayor. */
export const LEVELS = ['viewer', 'editor', 'manager'] as const;
export type Level = (typeof LEVELS)[number];
export const LEVEL_RANK: Record<Level, number> = { viewer: 1, editor: 2, manager: 3 };

export function levelAtLeast(have: Level, need: Level): boolean {
  return LEVEL_RANK[have] >= LEVEL_RANK[need];
}

/** Estado de una persona programada en un servicio. */
export const SCHEDULE_STATUSES = ['C', 'U', 'D'] as const;
export type ScheduleStatus = (typeof SCHEDULE_STATUSES)[number];

export const GENDERS = ['male', 'female'] as const;
export type Gender = (typeof GENDERS)[number];

export const PERSON_STATUSES = ['active', 'inactive'] as const;
export const MEMBERSHIPS = ['member', 'regular_attender', 'visitor', 'participant', 'none'] as const;
export type Membership = (typeof MEMBERSHIPS)[number];

export const MARITAL_STATUSES = ['single', 'married', 'widowed', 'divorced', 'separated'] as const;

export const CONTACT_LOCATIONS = ['home', 'work', 'mobile', 'other'] as const;

export const PLAN_ITEM_TYPES = ['song', 'header', 'media', 'item'] as const;
export type PlanItemType = (typeof PLAN_ITEM_TYPES)[number];

export const PLAN_TIME_KINDS = ['service', 'rehearsal', 'other'] as const;

export const TONALITIES = ['major', 'minor'] as const;
export type Tonality = (typeof TONALITIES)[number];

export const FIELD_TYPES = ['text', 'textarea', 'number', 'date', 'boolean', 'select', 'checkboxes'] as const;
export type FieldType = (typeof FIELD_TYPES)[number];

export const PAYMENT_METHODS = ['cash', 'check', 'card', 'ach', 'other'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const DONATION_STATUSES = ['pending', 'succeeded', 'failed', 'refunded', 'partially_refunded'] as const;
export type DonationStatus = (typeof DONATION_STATUSES)[number];

export const RECURRING_FREQUENCIES = ['weekly', 'every_two_weeks', 'monthly'] as const;
export type RecurringFrequency = (typeof RECURRING_FREQUENCIES)[number];

export const CHECKIN_KINDS = ['regular', 'guest', 'volunteer'] as const;
export type CheckinKind = (typeof CHECKIN_KINDS)[number];

export const STATION_MODES = ['self', 'manned', 'roster'] as const;

export const GROUP_ROLES = ['leader', 'member'] as const;
export type GroupRole = (typeof GROUP_ROLES)[number];

export const ENROLLMENT_MODES = ['open', 'request', 'closed'] as const;

export const BOOKING_STATUSES = ['pending', 'approved', 'rejected'] as const;
export const EVENT_STATUSES = ['pending', 'approved', 'rejected', 'canceled'] as const;

export const REGISTRATION_STATUSES = ['pending_payment', 'confirmed', 'waitlisted', 'canceled'] as const;

export const TASK_REPEATS = ['none', 'daily', 'weekly', 'monthly', 'yearly'] as const;
export type TaskRepeat = (typeof TASK_REPEATS)[number];

export const CHANNELS = ['email', 'sms', 'whatsapp', 'in_app'] as const;
export type Channel = (typeof CHANNELS)[number];

export const WIDGET_TYPES = [
  'services_my_schedule',
  'services_attendance',
  'services_people_schedulings',
  'services_schedule_plans_forecast',
  'services_schedule_team_breakdown',
  'people_birthdays',
  'people_anniversaries',
  'people_new_profiles',
  'giving_amount_donated',
  'giving_open_batches',
  'checkins_headcounts',
  'groups_attendance',
  'calendar_upcoming_events',
  'calendar_pending_approvals',
  'registrations_recent',
  'home_tasks',
  'home_notepad',
  'home_quick_links',
] as const;
export type WidgetType = (typeof WIDGET_TYPES)[number];

/** Momento de un ítem respecto a la Reunión: lo de antes y después no suma a su duración. */
export const PLAN_ITEM_POSITIONS = ['before', 'during', 'after'] as const;
